import { coreInitiativesLinksGetAsyncSlice } from './get';
import { CoreInitiativesLinksName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteInitiativeLinkRequest } from '@api';

export const coreInitiativesLinksRemoveSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesLinksName,
	state: coreInitiativesLinksGetAsyncSlice.asyncState,
	target: (request: DeleteInitiativeLinkRequest) => (link) => link.id === request.id
});
